import { useEffect, useState } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import Table from '../../../components/tables/TableFilter'
import Button from '../../../components/common/Button'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'

const Entregables = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos 
    const [idEntregable, setIdEntregable] = useState("")
    const [expediente, setExpediente] = useState("")
    const [formaEntrega, setFormaEntrega] = useState("")
    const [entidad, setEntidad] = useState("")
    // modales
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaciones y cargas 
    const [error, setError] = useState("")
    const [cargando, setCargando] = useState(true)
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)
    //seleccion de fila
    const [selectedId, setSelectedId] = useState(null)
    //datos para la tabla
    const columnas = [
        { titulo: 'Tipo Expediente', campo: 'expediente' },
        { titulo: 'Forma de entrega', campo: 'forma_entrega' },
        { titulo: 'Entidad', campo: 'entidad' },
    ]

    // Carga inicial de las Entregableses
    useEffect(() => { obtenerEntregables() }, [])

    // Función para traer las Entregables
    const obtenerEntregables = async () => {
        const respuesta = await consumirApi('GET', `maestros/entregable/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    // Registro de una nueva ubicación
    const registrarEntregables = (async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/entregable`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Entregable registrado correctamente" })
            limpiarCampos()
            obtenerEntregables()
        }
        else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    })

    // funcion para abrir el modal para editar Entregables
    const abrirModalEditar = (data) => {
        setIdEntregable(data.id)
        setExpediente(data.expediente)
        setFormaEntrega(data.forma_entrega)
        setEntidad(data.entidad)
        setMostrarModalEditar(true)
    }

    // Edición entregables
    const enviarEdicionEntregable = async (e) => {
        e.preventDefault()
        const data = { expediente, forma_entrega: formaEntrega, entidad }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/entregable/${idEntregable}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Entregable actualizada correctamente" })
            limpiarCampos()
            obtenerEntregables()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Manejar selección de checkbox
    const seleccionEntregable = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }

    // funcion para eliminar Entregable
    const eliminarEntregable = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/entregable/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "AEntregable eliminado correctamente" })
            limpiarCampos()
            obtenerEntregables()
        } else {
            setError(respuesta.error)
        }
    }

    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setError('')
        setSelectedId(null)
        setIdEntregable('')
        setExpediente('')
        setFormaEntrega('')
        setEntidad('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2" type="delete" disabled={!selectedId} onClick={()=>setMostrarModalEliminar(true)} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron Entregables</div>
                ) : (
                    <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
                        mostrarChecks={true}
                        seleccionFila={seleccionEntregable} // Manejar el ID seleccionado
                        selectedId={selectedId} // Manejar el ID seleccionado
                    />
                )
            )}

            {/* Modal Registrar nuevo Ubicación*/}
            <Modal isOpen={mostrarModal} title="Registrar nuevo entregable" onClose={limpiarCampos} >
                <Form onSubmit={registrarEntregables} isSubmitting={isSubmitting}>
                    <Input name="expediente" value={expediente} label="Tipo expediente" onChange={setExpediente} />
                    <Input name="forma_entrega" value={formaEntrega} label="Forma de entrega" onChange={setFormaEntrega} />
                    <Input name="entidad" value={entidad} label="Entidad" onChange={setEntidad} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal Actuazliar Entregables*/}
            <Modal isOpen={mostrarModalEditar} title="Actualizar entregable" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionEntregable}  isSubmitting={isSubmitting} type='update'>
                    <Input name="expediente" value={expediente} label="Tipo expediente" onChange={setExpediente} />
                    <Input name="forma_entrega" value={formaEntrega} label="Forma de entrega" onChange={setFormaEntrega} />
                    <Input name="entidad" value={entidad} label="Entidad" onChange={setEntidad} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un accion*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarEntregable}
                mensaje="¿Estás seguro de que deseas eliminar entregable?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>
        </div>
    )
}

export default Entregables
